class LazyLoadImages {
	
	init() {
		let images = document.querySelectorAll('img[data-src]');

		images.forEach(image => {
			image.setAttribute('src', image.getAttribute('data-src'));
			image.removeAttribute('data-src');

			image.onload = () => {
				console.log('image loaded', image);
				// image.nextSibling.style.opacity = 0;
			}
		});
	}

}
export default LazyLoadImages;